import * as types from '../types';

export function loginRequest(payload) {
   return {
      type: types.LOGIN_REQUEST,
      payload,
   };
}

export function loginSuccess(payload) {
   return {
      type: types.LOGIN_SUCCESS,
      payload,
   };
}

export function loginFailure(payload) {
   return {
      type: types.LOGIN_FAILURE,
      payload,
   };
}

export function logoutRequest(payload) {
   return {
      type: types.LOGOUT_REQUEST,
      payload,
   };
}

export function logoutSuccess(payload) {
   return {
      type: types.LOGOUT_SUCCESS,
      payload,
   };
}

export function logoutFailure(payload) {
   return {
      type: types.LOGOUT_FAILURE,
      payload,
   };
}

// Reflete no redux o que `PUT /users/me` gravou (hoje: só o nome), para que a
// sidebar e o menu do usuário mostrem o valor novo sem exigir novo login.
// payload: campos do usuário a mesclar, ex. { nome }.
export function authUserUpdated(payload) {
   return {
      type: types.AUTH_USER_UPDATED,
      payload,
   };
}

// 2FA (novo fluxo)
export function auth2FARequired(payload) {
   return {
      type: types.AUTH_2FA_REQUIRED,
      payload, // { preAuthId, email }
   };
}

export function auth2FAClear() {
   return {
      type: types.AUTH_2FA_CLEAR,
   };
}

export function auth2FAVerifyRequest(payload) {
   return {
      type: types.AUTH_2FA_VERIFY_REQUEST,
      payload, // { preAuthId, code, prevPath, navigate }
   };
}

export function auth2FAVerifyFailure(payload) {
   return {
      type: types.AUTH_2FA_VERIFY_FAILURE,
      payload,
   };
}

export function auth2FAResendRequest(payload) {
   return {
      type: types.AUTH_2FA_RESEND_REQUEST,
      payload, // { email, password }
   };
}

export function auth2FAResendFailure(payload) {
   return {
      type: types.AUTH_2FA_RESEND_FAILURE,
      payload,
   };
}
